import { Navigate, useParams } from "react-router-dom";

/**
 * <PathRedirect to="/cashier/sales/:saleId" /> — substitutes route params.
 */
export const PathRedirect = ({ to, replace = true }) => {
  const params = useParams();
  let target = to;
  Object.entries(params).forEach(([k, v]) => {
    target = target.replace(`:${k}`, v ?? "");
  });
  return <Navigate to={target} replace={replace} />;
};
